"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _handlebars = _interopRequireDefault(require("handlebars"));

var _underscore = _interopRequireDefault(require("underscore"));

var _moment = _interopRequireDefault(require("moment"));

var _twix = _interopRequireDefault(require("twix"));

var _Global = _interopRequireDefault(require("models/Global"));

var _paymentMethodEnum = _interopRequireDefault(require("./enums/paymentMethodEnum"));

var defaultSponsorLevelsEnum = _interopRequireWildcard(require("./enums/defaultSponsorLevelsEnum"));

var _monthEnum = _interopRequireDefault(require("./enums/monthEnum"));

var _timeAgo = _interopRequireDefault(require("./utils/timeAgo"));

var _config = _interopRequireDefault(require("config"));

var _TemplatesConfig = _interopRequireDefault(require("./TemplatesConfig"));

var _FeatureToggleUtils = _interopRequireDefault(require("./utils/FeatureToggleUtils"));

var _whitelabelUtils = require("./utils/whitelabelUtils");

var _countryList = require("@bizzabo/country-list");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_moment.default.fn.fromNowOrNow = function (date, format) {
  var diff = Math.abs((0, _moment.default)().diff(this));
  var hour = 60 * 60 * 1000;
  var startOfDay = (0, _moment.default)(this).startOf('day');
  var isToday = startOfDay.isSame((0, _moment.default)().startOf('day'));
  var isYesterday = startOfDay.isSame((0, _moment.default)().startOf('day').subtract(1, 'd'));

  if (diff < 25 * 1000) {
    return 'Just now';
  } else if (diff < hour) {
    return this.fromNow();
  } else if (isToday) {
    return 'Today at ' + this.format('hh:mma');
  } else if (isYesterday) {
    return 'Yesterday at ' + this.format('hh:mma');
  } else {
    return this.format(format);
  }
};

var formatDateTimeToPeriodFormat = {
  'DD/MM/YYYY': {
    L: 'DD/MM/YYYY',
    LL: 'D MMMM YYYY',
    LLL: 'D MMMM YYYY HH:mm',
    LLLL: 'dddd D MMMM YYYY HH:mm',
    LT: 'HH:mm',
    LTS: 'HH:mm:ss'
  },
  default: {
    L: 'MM/DD/YYYY',
    LL: 'MMMM D, YYYY',
    LLL: 'MMMM D, YYYY h:mm A',
    LLLL: 'dddd, MMMM D, YYYY h:mm A',
    LT: 'h:mm A',
    LTS: 'h:mm:ss A'
  }
};

_handlebars.default.registerHelper('toJSON', function (obj) {
  return JSON.stringify(obj || {});
});

_handlebars.default.registerHelper('unescaped_toJSON', function (obj) {
  return new _handlebars.default.SafeString(JSON.stringify(obj || {}));
});

_handlebars.default.registerHelper('unescapedHTML', function (html) {
  if (_underscore.default.isUndefined(html)) {
    return '';
  }

  return new _handlebars.default.SafeString(html);
});

_handlebars.default.registerHelper('trim', function (str) {
  return new _handlebars.default.SafeString(_handlebars.default.Utils.escapeExpression(str && str.trim()));
});

_handlebars.default.registerHelper('toLowerCase', function (str) {
  return str && str.toLowerCase();
});

_handlebars.default.registerHelper('getFullContactName', function () {
  var _this = this;

  var displayAttributes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var options = arguments.length > 1 ? arguments[1] : undefined;

  var getAttrByKeyName = function getAttrByKeyName(keyName) {
    return displayAttributes.find(function (attr) {
      return attr.keyName === keyName;
    });
  };

  var getDisplayProperty = function getDisplayProperty(keyName) {
    var elem = getAttrByKeyName(keyName);
    return elem && elem.show && _this[keyName] ? _this[keyName] + ' ' : '';
  };

  var prefix = getDisplayProperty('prefix');
  var firstName = getDisplayProperty('firstName');
  var lastName = getDisplayProperty('lastName');
  return "".concat(prefix).concat(firstName).concat(lastName);
});

var renderContactAttributeField = function renderContactAttributeField(_ref, value) {
  var type = _ref.type;

  if (type === 'date') {
    return value ? (0, _moment.default)(value).format('MMM DD, YYYY') : '';
  }

  if (type === 'url') {
    return value ? new _handlebars.default.SafeString("<a target=\"_top\" href=\"".concat(value, "\">").concat(value, "</a>")) : '';
  }

  return value;
};

_handlebars.default.registerHelper('renderContactField', function () {
  var displayAttributes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var keyName = arguments.length > 1 ? arguments[1] : undefined;
  var options = arguments.length > 2 ? arguments[2] : undefined;
  var attribute = displayAttributes.find(function (attribute) {
    return attribute.keyName === keyName;
  });
  return attribute && attribute.show && this[keyName] ? renderContactAttributeField(attribute, this[keyName]) : '';
});

_handlebars.default.registerHelper('renderCustomContactField', function () {
  var displayAttributes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var index = arguments.length > 1 ? arguments[1] : undefined;
  var fixedAttributes = ['prefix', 'firstName', 'lastName', 'facebookPage', 'linkedinPage', 'twitter'];
  var customFieldsCounter = 0;
  var elem = displayAttributes.find(function (attr) {
    var isCustom = !fixedAttributes.includes(attr.keyName);

    if (isCustom) {
      customFieldsCounter++;
    }

    return isCustom && index === customFieldsCounter;
  });
  return elem && elem.show && this[elem.keyName] ? renderContactAttributeField(elem, this[elem.keyName]) : '';
});

_handlebars.default.registerHelper('isNeedToShowContactField', function () {
  var displayAttributes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var keyName = arguments.length > 1 ? arguments[1] : undefined;
  var elem = displayAttributes.find(function (attr) {
    return attr.keyName === keyName;
  });
  return elem && elem.show && this[keyName];
});

_handlebars.default.registerHelper('trimLastName', function (lastName, options) {
  var firstLetter = lastName && lastName.charAt(0).toUpperCase();
  return firstLetter + '.';
});

_handlebars.default.registerHelper('floor', function (val) {
  val = parseFloat(val);
  return Math.floor(val);
});

_handlebars.default.registerHelper('isOdd', function (number, options) {
  return number % 2 === 1 ? options.fn(this) : options.inverse(this);
});

_handlebars.default.registerHelper('eq', function (val, val2, options) {
  return val == val2 ? options.fn(this) : options.inverse(this);
});

_handlebars.default.registerHelper('or', function (val, val2, options) {
  return val || val2 ? options.fn(this) : options.inverse(this);
});

_handlebars.default.registerHelper('lt', function (val, val2, options) {
  return val < val2 ? options.fn(this) : options.inverse(this);
});

_handlebars.default.registerHelper('gt', function (val, val2, options) {
  return val > val2 ? options.fn(this) : options.inverse(this);
}); // Helper name in shared resource should match to the one used in webattendee


_handlebars.default.registerHelper('ifGt', function (v1, v2, options) {
  if (v1 > v2) {
    return options.fn(this);
  }

  return options.inverse(this);
});

_handlebars.default.registerHelper('ifEq', function (v1, v2, options) {
  if (v1 === v2) {
    return options.fn(this);
  }

  return options.inverse(this);
});

_handlebars.default.registerHelper('ifLt', function (v1, v2, options) {
  if (v1 < v2) {
    return options.fn(this);
  }

  return options.inverse(this);
});

_handlebars.default.registerHelper('neq', function (val, val2, options) {
  return val != val2 ? options.fn(this) : options.inverse(this);
});

_handlebars.default.registerHelper('sub', function (val, val2, options) {
  return val - val2;
});

_handlebars.default.registerHelper('subOne', function (val, options) {
  return val - 1;
});

_handlebars.default.registerHelper('addOne', function (val, options) {
  return val + 1;
});

_handlebars.default.registerHelper('comToPrev', function (val, val2, options) {
  if (val2 === 0) {
    return '-';
  } else {
    return val - val2 > 0 ? '+ %' + Math.round((val - val2) / (val + val2) * 100) : '- %' + Math.round((val2 - val) / (val + val2) * 100);
  }
});

_handlebars.default.registerHelper('moduloPlusOne', function (num, mod) {
  num = num !== undefined ? num : 0;
  return num % mod + 1;
});

_handlebars.default.registerHelper('shouldShowTab', function (role, allowedRoles, tab, options) {
  var features = _config.default.features || {};

  if (tab.name === 'analytics') {
    if (features.showRegistrationDashboard || features.showRevenueDashboard || features.showEmailMarketingDashboard) {
      return options.fn(this);
    } else {
      return options.inverse(this);
    }
  }

  var allowed = _underscore.default.isEmpty(allowedRoles) || _underscore.default.contains(allowedRoles, role);

  return allowed ? options.fn(this) : options.inverse(this);
});

_handlebars.default.registerHelper('moment', function (date, format, daysToAdd) {
  daysToAdd = daysToAdd || 0;
  format = format || 'MMM DD, YYYY';
  return (0, _moment.default)(date).add(daysToAdd, 'd').format(format);
});

_handlebars.default.registerHelper('momentUTC', function (date, format, daysToAdd) {
  daysToAdd = daysToAdd || 0;
  format = format || 'MMM DD, YYYY';
  return _moment.default.utc(date).add(daysToAdd, 'd').format(format);
});

_handlebars.default.registerHelper('toAmpm', function (time) {
  var format = 'h:mma';
  return (0, _moment.default)(time, 'H:mm').format(format);
});

_handlebars.default.registerHelper('toEndTime', function (time, duration) {
  var format = 'h:mma';
  return (0, _moment.default)(time, 'H:mm').add(duration, 'm').format(format);
});

_handlebars.default.registerHelper('timeago', function (date, format) {
  format = format || 'MMM DD, YYYY';
  return (0, _moment.default)(date).fromNowOrNow(date, format);
});

_handlebars.default.registerHelper('twix', function (date1, date2) {
  return (0, _moment.default)(date1).twix(date2, true).format({
    implicitYear: false
  });
});

_handlebars.default.registerHelper('getFromMap', function (map, key, options) {
  if (!map) {
    console.log('map was undefined in template. key: ', key);
    return undefined;
  }

  return map[key];
});

_handlebars.default.registerHelper('partial', function (name, ctx) {
  if (_underscore.default.isEmpty(name)) {
    return;
  }

  var ps = _handlebars.default.partials;

  if (typeof ps[name] != 'function') {
    ps[name] = _handlebars.default.compile(ps[name], ctx);
  }

  return ps[name](ctx);
});

_handlebars.default.registerHelper('setDangerHTML', function (name) {
  return new _handlebars.default.SafeString(_handlebars.default.Utils.escapeExpression(name));
});

_handlebars.default.registerHelper('firstLetter', function (name, options) {
  if (typeof name !== 'string') {
    return name;
  }

  var firstLetter = name && name.charAt(0).toUpperCase();
  return firstLetter;
});

_handlebars.default.registerHelper('attribueValueDisplay', function (type, valueArr) {
  var displayString = '';

  if (valueArr) {
    switch (type) {
      case 'date':
        displayString = valueArr[0] ? (0, _moment.default)(parseInt(valueArr[0], 10)).format('M/D/YYYY') : '';
        break;

      case 'waiver':
      case 'bool':
        displayString = valueArr[0] == 'true' ? 'Yes' : 'No';
        break;

      default:
        displayString = valueArr.join(', ');
        break;
    }
  }

  return displayString;
});

_handlebars.default.registerHelper('priceDisplay', function (priceInCents, currencySymbol, toFixed) {
  var hasCurrency = currencySymbol && typeof currencySymbol == 'string';
  var isNegative = priceInCents < 0;

  if (isNegative) {
    currencySymbol = '-' + currencySymbol;
    priceInCents *= -1;
  }

  var html = hasCurrency ? '<span class="currency-display">' + currencySymbol + '</span>' : '';
  var number = Math.round(priceInCents || 0) / 100;

  if (_underscore.default.isNumber(toFixed)) {
    number = number.toFixed(toFixed);
  }

  html += _handlebars.default.helpers.numberDisplay(number);
  return new _handlebars.default.SafeString(html);
});

_handlebars.default.registerHelper('payoutDisplay', function (interval) {
  if (!interval) {
    return;
  } // Main roles - fixed colors


  switch (interval) {
    case 'weekly':
      return 'weekly';

    case 'biweekly':
      return 'bi-weekly';

    case 'monthly':
      return 'monthly';
  }
});

_handlebars.default.registerHelper('payoutDates', function (interval) {
  if (!interval) {
    return;
  } // Main roles - fixed colors


  switch (interval) {
    case 'weekly':
      return '2nd, 9th, 16th, and 23rd';

    case 'biweekly':
      return '2nd and the 16th';

    case 'monthly':
      return '2nd';
  }
});

_handlebars.default.registerHelper('historyActionDisplay', function (priceInCents, currencySymbol, action, ticketBoostRefund, swapped) {
  var historyTypes = ['partialRefund', 'refund'];

  var tempAction = _handlebars.default.helpers.paymentStatusDisplay(action);

  var html = '';
  var priceDisplay = '';

  if (Math.abs(priceInCents) > 0) {
    priceDisplay = _handlebars.default.helpers.priceDisplay(Math.abs(priceInCents), currencySymbol);
  }

  if (_underscore.default.contains(historyTypes, action)) {
    html += priceDisplay + ' ';

    if (ticketBoostRefund) {
      tempAction = 'Ticket Boost Referal';
    } else {
      tempAction = 'Refund';
    }
  } else if (action === 'processed') {
    tempAction = 'Purchase';
  } else if (swapped) {
    tempAction = 'Swapped';
  } else if (action === 'pending') {
    tempAction = 'Invoice Purchase';
  }

  html += tempAction;
  return new _handlebars.default.SafeString(html);
});

_handlebars.default.registerHelper('organizerAbzorbFee', function (totals, currencySymbol) {
  var hasCurrency = currencySymbol && typeof currencySymbol == 'string';
  var html = hasCurrency ? '<span class="currency-display">' + currencySymbol + '</span>' : '';
  html += _handlebars.default.helpers.numberDisplay(Math.round(totals.organizerAbsorbedFee || 0) / 100);
  return new _handlebars.default.SafeString(html);
});

_handlebars.default.registerHelper('numberDisplay', function (number) {
  if (!number) {
    return '0';
  }

  var parts = number.toString().split('.');
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');

  if (parts[1]) {
    parts[1] = parts[1].length == 1 ? parts[1] + '0' : parts[1];
  }

  return parts.join('.');
});

_handlebars.default.registerHelper('statusDisplay', function (serverStatus) {
  switch (serverStatus) {
    case 'keep':
      return 'In Process';

    case 'processed':
      return 'Completed';

    case 'canceled':
      return 'Canceled & Reimbursed';

    case 'refund':
      return 'Refunded';

    case 'partialRefund':
      return 'Partially Refunded';

    case 'pending':
      return 'Pending Payment';

    case 'Total':
      return 'Total';
  }

  return 'Unknown';
});

_handlebars.default.registerHelper('registrationStatusDisplay', function (serverStatus) {
  switch (serverStatus) {
    case 'processed':
      return 'Valid';

    case 'canceled':
      return 'Canceled';

    case 'refund':
      return 'Valid';

    case 'partialRefund':
      return 'Valid';

    case 'pending':
      return 'Valid';

    case 'Total':
      return 'Total';
  }

  return 'Unknown';
});

_handlebars.default.registerHelper('paymentStatusDisplay', function (serverStatus) {
  switch (serverStatus) {
    case 'processed':
      return 'Completed';

    case 'canceled':
      return 'Refund';

    case 'refund':
      return 'Refunded';

    case 'partialRefund':
      return 'Refunded';

    case 'pending':
      return 'Pending Payment';

    case 'Total':
      return 'Total';
  }

  return 'Unknown';
});

_handlebars.default.registerHelper('validityDisplay', function (status) {
  switch (status) {
    case 'valid':
      return 'Valid';

    case 'invalid':
      return 'Canceled';
  }

  return '';
});

_handlebars.default.registerHelper('validityActionDisplay', function (status) {
  switch (status) {
    case 'valid':
      return 'Refund & keep ticket';

    case 'invalid':
      return 'Refund & cancel ticket';
  }

  return '';
});

_handlebars.default.registerHelper('promoTypeDisplay', function (type) {
  switch (type) {
    case 'track':
      return 'Tracking Only';

    case 'discount':
      return 'Ticket Discount';

    case 'visibility':
      return 'Invisible Tickets';

    case 'social':
      return 'Ticket Boost Referral';
  }

  return '';
});

_handlebars.default.registerHelper('orderTypeDisplay', function (orderType) {
  switch (orderType) {
    case 'online':
      return 'Online';

    case 'manual':
      return 'Assigned';

    case 'invoice':
      return 'Invoice';

    case 'api':
      return 'External / Api';

    default:
      return 'Online';
  }
});

_handlebars.default.registerHelper('planStatusDisplay', function (planStatus) {
  switch (planStatus) {
    case 'pending':
      return 'Pending';

    case 'reviewed':
      return 'Reviewed';

    case 'pendingPayment':
      return 'Pending Payment';

    case 'updated':
      return 'Updated';

    case 'expired':
      return 'Expired';

    case 'trial':
      return 'Trial';

    case 'paid':
      return 'Active (auto renewal)';

    case 'terminated':
      return 'Active (no renewal)';

    case 'trialExpired':
      return 'Trial Expired';
  }
});

_handlebars.default.registerHelper('roleColor', function (roleName) {
  if (!roleName) {
    return;
  } // Main roles - fixed colors


  switch (roleName) {
    case 'Attendee':
      return '#F26D4F';

    case 'Speaker':
      return '#F8AF5C';

    case 'Sponsor':
      return '#7DC476';

    case 'Vendor':
      return '#37BBB4';

    case 'Partner':
      return '#8660A8';

    case 'Exhibitor':
      return '#00bcd4';
  } // Custom roles - fixed colors from name hash


  var colors = ['#fa6a53', '#fa8c5c', '#ffad65', '#28b87d', '#acd27b', '#28b87d', '#3cafe4', '#2b8ec7', '#4b76b5', '#5b5ea5', '#aa64a6', '#f66da8', '#796b7d'];
  var hash = 0;

  for (var i = 0; i < roleName.length; i++) {
    hash += roleName.charCodeAt(i);
  }

  var index = hash % colors.length;
  return colors[index];
});

_handlebars.default.registerHelper('streamIconClass', function (type) {
  switch (type) {
    case 'ORDER_REFUND':
    case 'CANCEL_INVOICE':
      return 'icon-down_arrow';

    case 'TICKET_TRANSACTION':
      return 'icon-up_arrow';

    case 'SHARE':
      return 'icon-social_share';

    case 'TICKETS_CHECKING':
      return 'icon-OnSiteCheckin';

    case 'TICKETS_VIRTUALLY_CHECKING':
      return 'icon-OnSiteCheckin';
  }

  return '';
});

_handlebars.default.registerHelper('socialNetworksDisplay', function (networksArr) {
  var networks = {
    LINKEDIN: 'LinkedIn',
    TWITTER: 'Twitter',
    FACEBOOK: 'Facebook'
  };

  var networksMap = function networksMap(network) {
    return networks[network];
  };

  return _underscore.default.map(networksArr, networksMap).join(', ');
});

_handlebars.default.registerHelper('config', function (attribute) {
  return _config.default[attribute];
});

_handlebars.default.registerHelper('ordinalOptions', function (min, max) {
  max = max || 10;
  var options = '<option value="0">0</option>';

  for (var i = min; i <= max; i++) {
    options += '<option value="' + i + '">' + i + '</option>';
  }

  return new _handlebars.default.SafeString(options);
});

_handlebars.default.registerHelper('buildPath', function (accountId, eventId, type, ctx) {
  var tab = ctx;

  if (type == 'settings') {
    return '/settings/' + tab.name;
  } else if (type == 'account') {
    return '/' + accountId + '/' + tab.name;
  } else if (type == 'events') {
    return '/' + accountId + '/events/' + eventId + '/' + tab.name;
  }
});

_handlebars.default.registerHelper('globalCall', function (object, func) {
  var restArgs = Array.prototype.slice.call(arguments, 2);

  var obj = _Global.default.get(object);

  if (obj && typeof obj[func] === 'function') {
    return obj[func].apply(obj, restArgs);
  }

  return '';
});

_handlebars.default.registerHelper('global', function (object, prop) {
  if (_Global.default.get(object)) {
    return _Global.default.get(object).get(prop);
  }

  return '';
});

_handlebars.default.registerHelper('globalField', function (prop) {
  return _Global.default.get(prop);
});

_handlebars.default.registerHelper('calcPercentage', function (num, total) {
  if (!num || !total || total === 0) {
    return;
  }

  return Math.round(num / total * 100);
});

_handlebars.default.registerHelper('getPrefix', function () {
  var websiteType = _Global.default.get('websiteType');

  var whitelabelPath = _Global.default.get('whitelabelPath');

  var whitelabelWidgetEnabled = _Global.default.get('whitelabelWidgetEnabled');

  var uniqueName = _Global.default.get('uniqueName');

  var onlyEventDomain = _Global.default.get('onlyEventDomain');

  return (0, _whitelabelUtils.getInternalWebsitePath)({
    websiteType: websiteType,
    whitelabelPath: whitelabelPath,
    whitelabelWidgetEnabled: whitelabelWidgetEnabled,
    uniqueName: uniqueName,
    onlyEventDomain: onlyEventDomain
  });
});

_handlebars.default.registerHelper('getEventId', function () {
  return _Global.default.get('eventId');
});

_handlebars.default.registerHelper('feature', function (feature, options) {
  return _FeatureToggleUtils.default.isFeatureEnabled(feature) ? options.fn(this) : options.inverse(this);
});

_handlebars.default.registerHelper('noFeature', function (feature, options) {
  return !_FeatureToggleUtils.default.isFeatureEnabled(feature) ? options.fn(this) : options.inverse(this);
});

_handlebars.default.registerHelper('eventUrl', function (accountId, eventId) {
  var url = '/' + accountId + '/events/' + eventId;
  return new _handlebars.default.SafeString(url);
});

_handlebars.default.registerHelper('multiElementSize', function (section) {
  var multiElement = section.multiElement;
  var visibleCount = 0;

  _underscore.default.each(multiElement.entities, function (entity) {
    if (entity.visibility) {
      visibleCount++;
    }
  }, this);

  return getColXSByCount(visibleCount);
});

function getColXSByCount(count) {
  switch (count) {
    case 1:
      return 'col-sm-12';

    case 2:
      return 'col-sm-6';

    case 3:
      return 'col-sm-4';

    default:
      return 'col-sm-12';
  }
}

_handlebars.default.registerHelper('inlineCSSRender', function (data, templateName) {
  var html = _handlebars.default.compiledTemplates[templateName + '/inline_css'](data);

  return new _handlebars.default.SafeString(html);
});

_handlebars.default.registerHelper('sectionStylesRender', function (section) {
  var html = _handlebars.default.partials.website_style_view(_underscore.default.extend(section, {
    customClass: '.section-' + section.rootKey
  }));

  return new _handlebars.default.SafeString(html);
});

_handlebars.default.registerHelper('customStylesRender', function (data, customClass) {
  var html = _handlebars.default.partials.website_style_view(_underscore.default.extend(data, {
    customClass: '.' + customClass
  }));

  return new _handlebars.default.SafeString(html);
});

_handlebars.default.registerHelper('hasColors', function (section, options) {
  var hasColors = false;

  var nonFalseValues = _underscore.default.pick(section, _underscore.default.identity);

  _underscore.default.each(_TemplatesConfig.default.colorKeys, function (colorKey) {
    hasColors = hasColors || _underscore.default.has(nonFalseValues, colorKey);
  });

  if (hasColors) {
    return options.fn(this);
  }

  return options.inverse(this);
});

_handlebars.default.registerHelper('sectionRender', function (section, type, templateName) {
  var html;

  if (section.renderedHtml) {
    html = section.renderedHtml;
  } else {
    switch (type) {
      case 'navigation':
        {
          html = _handlebars.default.compiledTemplates[templateName + '/navigation'](section);
          break;
        }

      case 'footer':
        {
          html = _handlebars.default.compiledTemplates[templateName + '/footer'](section);
          break;
        }

      default:
        {
          var template = _handlebars.default.compiledTemplates[section.template + '/' + section.type] || _handlebars.default.compiledTemplates['common' + '/' + section.type];
          html = template && template(section);
        }
    }
  }

  var wrapperDiv = '<div class="' + section.template + '-template section-' + section.rootKey + '" data-server-rendered="' + _config.default.serverRendered + '" data-model-id="' + section.id + '">' + html + '</div>';
  return new _handlebars.default.SafeString(wrapperDiv);
});

_handlebars.default.registerHelper('formatEventDate', function (startDate, endDate, formatDate) {
  var incomeFormat = typeof formatDate === 'string' ? formatDate : 'default';

  var longDateFormat = _moment.default.localeData()._longDateFormat;

  _moment.default.updateLocale(_moment.default.locale(), {
    longDateFormat: formatDateTimeToPeriodFormat[incomeFormat] || formatDateTimeToPeriodFormat.default
  });

  var dateFormat = 'YYYY-MM-DD HH:mm';
  var formattedStartDate = (0, _moment.default)(startDate, dateFormat);
  var formattedEndDate = (0, _moment.default)(endDate, dateFormat);
  var result = formattedStartDate.twix(formattedEndDate, {
    allDay: true
  }).format({
    implicitYear: false,
    monthFormat: 'MMMM',
    dayFormat: 'Do'
  });

  _moment.default.updateLocale(_moment.default.locale(), {
    longDateFormat: longDateFormat
  });

  return result;
});

_handlebars.default.registerHelper('sessionStartTime', function (session) {
  if (!session.startDate || !session.endDate) {
    return 'Not Scheduled';
  }

  var start = _moment.default.utc(session.startDate).add(session.startMinute, 'minutes');

  return "".concat(start.format('MM/DD/YYYY'), " ").concat(start.format('hh:mm A'));
});

_handlebars.default.registerHelper('hexToRgba', function (hex, alpha) {
  var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  var parsedResult = result ? {
    r: parseInt(result[1], 16),
    g: parseInt(result[2], 16),
    b: parseInt(result[3], 16),
    a: alpha
  } : null;

  if (parsedResult) {
    return 'rgba(' + parsedResult.r + ', ' + parsedResult.g + ', ' + parsedResult.b + ', ' + parsedResult.a + ')';
  } else {
    return '';
  }
});

_handlebars.default.registerHelper('encodeURIComponent', function (component) {
  component = component || '';
  return encodeURIComponent(component);
});

_handlebars.default.registerHelper('isMobile', function (options) {
  var isMobile = _Global.default.get('isMobile');

  if (isMobile) {
    return options.fn(this);
  } else {
    return options.inverse(this);
  }
});

_handlebars.default.registerHelper('isNotMobile', function (options) {
  var isMobile = _Global.default.get('isMobile');

  if (!isMobile) {
    return options.fn(this);
  } else {
    return options.inverse(this);
  }
});

_handlebars.default.registerHelper('imageSizer', function (photoSet) {
  var isMobile = _Global.default.get('isMobile');

  if (isMobile) {
    return photoSet && photoSet.medium ? photoSet.medium : '';
  } else {
    return photoSet && photoSet.large ? photoSet.large : '';
  }
});

_handlebars.default.registerHelper('calcWowDelay', function (index, obj) {
  var baseDelay = 0.10;
  var offset = 0.10;
  return baseDelay + offset * (index % 4) + 's';
});

_handlebars.default.registerHelper('getCountryByCode', function (countryCode) {
  var country = (0, _countryList.getCountryName)(countryCode);
  return country || 'United States';
});

_handlebars.default.registerHelper('getPaymentMethod', function (paymentMethod) {
  var paymentMethodResult = _underscore.default.invert(_paymentMethodEnum.default)[paymentMethod];

  return paymentMethodResult || 'Other';
});

_handlebars.default.registerHelper('countryEnum', function (countryCode) {
  var countryName = (0, _countryList.getCountryName)(countryCode);
  return countryName !== null && countryName !== void 0 ? countryName : countryCode;
});

_handlebars.default.registerHelper('toMonth', function (month) {
  return _monthEnum.default[month];
});

_handlebars.default.registerHelper('timeAgo', function (timestamp) {
  return (0, _timeAgo.default)(timestamp);
});

_handlebars.default.registerHelper('allow_em_tags_only', function (str) {
  var html = str && str.toString() || '';
  html = html.split('PLACEHOLDER_EM_LEFT').join('');
  html = html.split('PLACEHOLDER_EM_RIGHT').join('');
  html = html.split('<em>').join('PLACEHOLDER_EM_LEFT');
  html = html.split('</em>').join('PLACEHOLDER_EM_RIGHT');
  html = _handlebars.default.Utils.escapeExpression(html);
  html = html.split('PLACEHOLDER_EM_LEFT').join('<em>');
  html = html.split('PLACEHOLDER_EM_RIGHT').join('</em>');
  return new _handlebars.default.SafeString(html);
}); // Should be removed when full editing enabled


_handlebars.default.registerHelper('disableEditing', function (sectionType, options) {
  var disabelEditing = {// sponsors: true,
    // downloadApp: true
  };
  return disabelEditing[sectionType] ? options.fn(this) : options.inverse(this);
});

_handlebars.default.registerHelper('text_with_line_breaks', function (str) {
  var html = str && str.toString() || '';
  html = _handlebars.default.Utils.escapeExpression(html);
  html = html.split('\n').join('<br>');
  return new _handlebars.default.SafeString(html);
});

_handlebars.default.registerHelper('getLinkUrl', function (tab) {
  switch (tab.type) {
    case 'custom':
      {
        return 'page/' + tab.id + '/' + tab.urlName;
      }

    case 'speakers':
    case 'sponsors':
    case 'exhibitors':
      {
        return 'page/' + tab.id + '/' + tab.type;
      }

    default:
      {
        return tab.type;
      }
  }
});

_handlebars.default.registerHelper('cdn', function (url) {
  var tag = process.env.DOCKER_IMAGE_TAG;
  var features = _config.default.features || {};

  if (features.azureCdn) {
    var isOrganizerDashboard = _config.default.hostUrl.indexOf('accounts') > -1;
    var azureCdnUrl = 'https://bizzabo.z13.web.core.windows.net';
    return "".concat(azureCdnUrl, "/").concat(isOrganizerDashboard ? 'dashboard' : 'attendee', "/").concat(tag).concat(url);
  }

  if (!_config.default.cdnUrl) {
    return url;
  } // process.env.DOCKER_IMAGE_TAG corresponds to build number
  // Client: see webpack/conf-base.js DefinePlugin
  // Server: see Dockerfile


  if (!tag) {
    return url;
  }

  return "".concat(_config.default.cdnUrl, "/").concat(tag).concat(url);
});

_handlebars.default.registerHelper('concat', function (a, b) {
  return a + '' + b;
});

_handlebars.default.registerHelper('isLatestVersion', function (id, lastSectionId, options) {
  if (_config.default.env !== 'prod') {
    return options.fn(this);
  }

  return id > lastSectionId ? options.fn(this) : options.inverse(this);
});

_handlebars.default.registerHelper('planLengthDisplay', function (type) {
  switch (type) {
    case 'sixMonth':
      return '6 months';

    case 'oneYear':
      return '12 months';

    case 'twoYear':
      return '24 months';

    case 'threeYear':
      return '36 months';
  }

  return '';
});

_handlebars.default.registerHelper('times', function (n, i, block) {
  var accum = '';
  i = i || 0;

  for (i; i < n; ++i) {
    accum += block.fn(i);
  }

  return accum;
});

_handlebars.default.registerHelper('isWidget', function (options) {
  return _Global.default.get('isWidget') ? options.fn(this) : options.inverse(this);
});

_handlebars.default.registerHelper('notWidget', function (options) {
  return !_Global.default.get('isWidget') ? options.fn(this) : options.inverse(this);
});

_handlebars.default.registerHelper('syncStatusDisplay', function (type) {
  switch (type) {
    case 'error':
      return 'Error';

    case 'inProgress':
      return 'In Progress';

    case 'success':
      return 'Success';

    default:
      return '-';
  }
});

_handlebars.default.registerHelper('isSEOTitleEnabled', function (event, tabSection, options) {
  var isSEOTitleEnabled = event.seoEnabled && tabSection && tabSection.seoEnabled && !!tabSection.seoTitle;
  return isSEOTitleEnabled ? options.fn(this) : options.inverse(this);
});

_handlebars.default.registerHelper('isPollAvailable', function (isJoined, isPollPrivate, isCommunityAvailable, options) {
  if (!isPollPrivate) {
    return options.fn(this);
  } else {
    return isJoined && isCommunityAvailable ? options.fn(this) : options.inverse(this);
  }
});

_handlebars.default.registerHelper('stringInclude', function (value, strOfValues, opts) {
  var arrayOfValues = strOfValues.split(' ');

  if (arrayOfValues.some(function (elem) {
    return elem === value;
  })) {
    return opts.fn(this);
  } else {
    return opts.inverse(this);
  }
});

_handlebars.default.registerHelper('debug', function (optionalValue) {
  console.log('Current Context', this);
  optionalValue && console.log('Value', optionalValue);
});

_handlebars.default.registerHelper('getTierColor', function (tierColor, tierLevel) {
  if (!tierColor && tierLevel) {
    var tierConfig = defaultSponsorLevelsEnum.levels.find(function (sponsorLevel) {
      return sponsorLevel.tier === tierLevel;
    });
    return tierConfig && tierConfig.color;
  }

  return '#' + tierColor;
});

_handlebars.default.registerHelper('getTierLabel', function (label, tierLevel) {
  if (!label && tierLevel) {
    var tierConfig = defaultSponsorLevelsEnum.levels.find(function (sponsorLevel) {
      return sponsorLevel.tier === tierLevel;
    });
    return tierConfig && tierConfig.label;
  }

  return label;
});

_handlebars.default.registerHelper('ifShowOnMobile', function (type, redirectUrl) {
  return type && (type === 'eventGroupLogin' || type === 'verifyUser' && !redirectUrl);
});

_handlebars.default.registerHelper('stringReverse', function (value) {
  return value && value.toString().split('').reverse().join('');
});

_handlebars.default.registerHelper('venueDisplay', function (venue) {
  if (!venue) {
    return '';
  }

  var venueDisplayAddress = venue['display-address'],
      venueName = venue.name;

  if (venueDisplayAddress && venueName) {
    return venueName + ', ' + venueDisplayAddress;
  } else {
    return venueDisplayAddress || venueName || '';
  }
});

_handlebars.default.registerHelper('addAccessibilityClasses', function (siteConf) {
  var accessibilityClasses = '';

  if (siteConf) {
    if (siteConf.accessibilityBiggerIdentifiers) {
      accessibilityClasses += ' bigger-identifiers';
    }
  }

  return accessibilityClasses;
});

_handlebars.default.registerHelper('noCacheUrl', function (url) {
  var noCachedUrl = "".concat(url, "?nocache=").concat(Date.now());
  return noCachedUrl;
});

_handlebars.default.registerHelper('displayPersonLabel', function (personProfileLink, personName) {
  var addEnding = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var personTitle = arguments.length > 3 ? arguments[3] : undefined;
  var company = arguments.length > 4 ? arguments[4] : undefined;
  var displayAsLink = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : true;
  var hasTitle = personTitle && personTitle.length > 0;
  var hasCompany = company && company.length > 0;

  var safeName = _handlebars.default.Utils.escapeExpression(personName);

  var safePersonTitle = _handlebars.default.Utils.escapeExpression(personTitle);

  var safeCompany = _handlebars.default.Utils.escapeExpression(company);

  var personLabel = displayAsLink ? "<a href=\"".concat(personProfileLink, "\" class=\"js-activity-stream-message-person-link\">").concat(safeName, "</a>") : safeName;
  personLabel += addEnding ? '\'s' : '';
  personLabel += hasTitle || hasCompany ? ', ' : '';
  personLabel += hasTitle ? "".concat(safePersonTitle, ", ") : '';
  personLabel += hasCompany ? "".concat(safeCompany, ", ") : '';
  return new _handlebars.default.SafeString(personLabel);
});

_handlebars.default.registerHelper('promoCodeApplyErrorMessage', function (promoCode, err) {
  // eslint-disable-next-line no-prototype-builtins
  var error = err && err.error;
  var errorCode = error && error['error-code'];
  var errorMessageFromServer = error && error.message;
  var errorMessage = 'Code Invalid';

  if (promoCode === '') {
    errorMessage = 'Enter Promo Code';
  } else if (errorCode === 4040) {
    errorMessage = 'That promo code is not associated with this event. Check your spelling?';
  } else if (errorCode === 4097) {
    errorMessage = 'That promo code has expired.';
  } else if (errorCode === 4008) {
    errorMessage = 'That promo code has not been activated yet. Try again later?';
  } else if (errorCode === 4004) {
    errorMessage = 'That promo code has reached its maximum number of uses.';
  } else if (errorCode === 4020) {
    errorMessage = errorMessageFromServer;
  }

  return errorMessage;
});

_handlebars.default.registerHelper('googleMapsApiKey', _config.default.googleMapsApiKey);

_handlebars.default.registerHelper('encodeURI', function (x) {
  return encodeURIComponent(x);
});

_handlebars.default.registerHelper('isNewRegistration', function (options) {
  if (_Global.default.get('registrationVersion') === 'V2') {
    return options.fn(this);
  } else {
    return options.inverse(this);
  }
});

_handlebars.default.registerHelper('registrationUrl', function (options) {
  return _config.default.registrationUrl;
});

_handlebars.default.registerHelper('queryString', function (options) {
  return _Global.default.get('queryString') || '';
});

_handlebars.default.registerHelper('isNeedToShowTooltip', function (tab, options) {
  var disabledTabsForTemplateEditor = ['social', 'polls', 'tweets', 'agenda'];

  if (disabledTabsForTemplateEditor.includes(tab)) {
    return options.fn(this);
  }

  return options.inverse(this);
});

_handlebars.default.registerHelper('contains', function (str, substring, options) {
  if (!str || str.includes(substring)) {
    return options.fn(this);
  }

  return options.inverse(this);
});

_handlebars.default.registerHelper('getLength', function (arr) {
  return arr ? arr.length : 0;
});

_handlebars.default.registerHelper('addLogoAsMetaTag', function (headerCustomCodeText, logo, options) {
  var substring = '<meta property="og:image"';

  if (logo) {
    if (headerCustomCodeText && headerCustomCodeText.includes(substring)) {
      return;
    }

    return options.fn(this);
  }
});

_handlebars.default.registerHelper('getCountryList', function () {
  var countryExceptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var eventCountries = arguments.length > 1 ? arguments[1] : undefined;
  var keyAsValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var block = arguments.length > 3 ? arguments[3] : undefined;
  // filter out initial null and not string values, and make sure initial values are upper-cased
  var newCountryExceptions = countryExceptions.reduce(function (result) {
    var _value$toUpperCase;

    var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref2$value = _ref2.value,
        value = _ref2$value === void 0 ? '' : _ref2$value;

    if (value !== null && value !== void 0 && (_value$toUpperCase = value.toUpperCase) !== null && _value$toUpperCase !== void 0 && _value$toUpperCase.call(value)) {
      result.push(value.toUpperCase());
    }

    return result;
  }, []); // add IHS sanctioned countries to the list of exceptions if feature is toggled on

  if (_FeatureToggleUtils.default.isFeatureEnabled('IHSRemoveSanctionedCountries')) {
    newCountryExceptions.push('KP', 'IR', 'SY', 'BY');
  } // add IBM banned countries to the list of exceptions if feature is toggled on


  if (_FeatureToggleUtils.default.isFeatureEnabled('IBMBannedCountries')) {
    newCountryExceptions.push('RU');
  } // get the list of countries, excluding exceptions as objects with code and name properties


  var countriesList = (0, _countryList.getFilteredCountryCodeList)({
    countriesMap: eventCountries,
    keyAsValue: keyAsValue,
    countryExceptions: newCountryExceptions,
    sortBy: 'text'
  }).map(function (_ref3) {
    var value = _ref3.value,
        text = _ref3.text;
    return {
      code: value,
      name: text
    };
  }); // create options from the list of countries

  var countryOptions = '';

  for (var i = 0; i < countriesList.length; ++i) {
    var _ref4 = countriesList[i] || {},
        code = _ref4.code,
        name = _ref4.name;

    block.data.value = keyAsValue ? code.toUpperCase() : code;
    block.data.text = name;
    countryOptions += block.fn(this);
  }

  return countryOptions;
});

var _default = _handlebars.default;
exports.default = _default;